angular.module('autoremind.dashboard.directives', [])
    .directive('dasboardWidgets', ['dashboardService', 'accountService', function (dashboardService, accountService) {
        return {
            restrict: 'E',
            templateUrl: 'app/dashboard/widgets/widget-template.html',
            scope: true,
            link: function ($scope, element, attr) {
                console.log('dasboardWidgets - accountService.isLoggedIn=' + accountService.currentUser !== undefined);
                $scope.dashboardService = dashboardService;
                $scope.widgetsDialogIsOpen = false;
                $scope.dashboardService = dashboardService;
                if (accountService.currentUser !== undefined) {
                    $scope.dashboardService.loadWidgets();
                }
                else {
                    $scope.$on('event:auth-loginConfirmed', function () {
                        console.log('dashboardWidgets: event:auth-loginConfirmed');
                        if ($scope.dashboardService.widgets === undefined || $scope.dashboardService.widgets.length === 0) {
                            $scope.dashboardService.loadWidgets();
                        }
                    });
                }
                $scope.checkIsEnabledCategory = function (widget) {
                    if (!angular.isDefined(widget.settings.communicationCategory) || !widget.settings.communicationCategory || !angular.isDefined(accountService.currentUser) || !accountService.currentUser.communication) {
                        return true;
                    }
                    for (var i in accountService.currentUser.communication.categories) {
                        var communicationCategory = accountService.currentUser.communication.categories[i];
                        if (communicationCategory.communicationsCategoryId === widget.settings.communicationCategory) {
                            return communicationCategory.categoryEnabled;
                        }
                    }
                    return true;
                };
                $scope.sortWidgetsOptions = {
                    update: function (e, ui) {
                        console.log('sortable');
                        dashboardService.saveWidgetsState();
                    },
                    'ui-floating': true
                };
            }
        };
    }])
    .directive('loadDynamicDirectives', ['$compile', '$parse', function ($compile, $parse) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attr) {
                attr.$observe('loadDynamicDirectives', function (val) {
                    element.html('');
                    var directive = $parse(val)(scope);
                    console.log('loadDynamicDirectives: ' + directive.directive + ', widgetType=' + directive.widgetType, val);
                    element.append($compile("<div " + directive.directive + " params='" + val + "'></div>")(scope));
                });
            }
        };
    }])
    .directive('widgetsHeader', ['$parse', function ($parse) {
        return {
            templateUrl: 'app/dashboard/widgets/widget-header-template.html',
            restrict: 'EA',
            scope: true,
            link: function (scope, elem, attr) {
            }
        };
    }]);
//# sourceMappingURL=dashboard.directives.js.map